export type WorkType = "电影" | "电视剧" | "综艺";

export interface WorkItem {
  id: string;
  title: string;
  enTitle?: string;
  type: WorkType;
  year: number;
  director: string;
  role: string;
  coStars: string[];
  synopsis: string;
  roleIntro: string;
  cover: string;
  stills: { src: string; alt: string }[];
  heat: number;
  highlight: string;
}

export const worksList: WorkItem[] = [
  {
    id: "w001",
    title: "南方来信",
    enTitle: "Letters from the South",
    type: "电影",
    year: 2027,
    director: "陈弈舟",
    role: "林书仪（旧书店店主）",
    coStars: ["周野", "林可为"],
    synopsis:
      "一间开了三十年的旧书店即将被收回，店主林书仪在整理库存的最后一个月里，迎来了久别归家的女儿。两人从生疏到重新学会相处，也重新读懂了那些被夹在书页之间的旧信。",
    roleIntro:
      "张柏芝在片中饰演的林书仪，是一个习惯把情绪收进抽屉的女人。她不擅长解释，也不擅长示弱，所有的话都在收银台后面那句“慢点看”里。导演要求她把表演压到最低，用停顿和呼吸来交代人物。",
    cover:
      "https://readdy.ai/api/search-image?query=Vertical%20movie%20poster%20of%20a%20woman%20in%20a%20beige%20knit%20sweater%20standing%20inside%20a%20warm%20dimly%20lit%20old%20bookshop%2C%20wooden%20shelves%20and%20stacks%20of%20books%20around%20her%2C%20soft%20rainy%20window%20light%2C%20muted%20brown%20and%20amber%20tones%2C%20elegant%20minimal%20cinematic%20composition&width=800&height=1200&seq=cecilia-work-001&orientation=portrait",
    stills: [
      {
        src: "https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20a%20small%20old%20bookshop%20interior%20with%20wooden%20ladders%20and%20warm%20amber%20lamps%2C%20a%20woman%20sorting%20books%20in%20the%20background%2C%20rain%20on%20the%20window%2C%20nostalgic%20film%20grain%20texture%2C%20muted%20earthy%20palette&width=1200&height=800&seq=cecilia-still-001a&orientation=landscape",
        alt: "《南方来信》剧照 旧书店内景",
      },
      {
        src: "https://readdy.ai/api/search-image?query=Film%20still%20of%20a%20wooden%20counter%20in%20an%20old%20bookshop%20with%20two%20bowls%20of%20noodles%20and%20a%20reading%20lamp%2C%20hands%20resting%20on%20the%20wood%2C%20warm%20sepia%20lighting%2C%20intimate%20quiet%20mood%2C%20cinematic%20close%20up&width=1200&height=800&seq=cecilia-still-001b&orientation=landscape",
        alt: "《南方来信》剧照 柜台与面碗",
      },
      {
        src: "https://readdy.ai/api/search-image?query=Atmospheric%20film%20still%20of%20a%20narrow%20old%20street%20in%20southern%20china%20after%20rain%2C%20woman%20with%20a%20canvas%20bag%20walking%20away%20from%20camera%2C%20warm%20dusk%20light%20on%20tiled%20walls%2C%20soft%20green%20and%20ochre%20palette&width=1200&height=800&seq=cecilia-still-001c&orientation=landscape",
        alt: "《南方来信》剧照 雨后老街",
      },
    ],
    heat: 96,
    highlight: "2027 最受期待华语片",
  },
  {
    id: "w002",
    title: "忘不了",
    enTitle: "Lost in Time",
    type: "电影",
    year: 2003,
    director: "尔冬升",
    role: "小慧",
    coStars: ["刘青云", "古天乐"],
    synopsis:
      "一场意外之后，小慧独自承担起生活的重量。她开着夜班小巴，在城市最疲惫的时刻载着陌生人回家，也一点点学会与失去共处。",
    roleIntro:
      "这是张柏芝最被反复讨论的表演之一。她把一个普通女人的倔强、笨拙和温柔演得毫不修饰，很多观众记住的是她在车上咬着面包、望向窗外的那个长镜头。",
    cover:
      "https://readdy.ai/api/search-image?query=Vertical%20nostalgic%20movie%20poster%20of%20a%20young%20woman%20in%20a%20simple%20white%20shirt%20leaning%20against%20a%20minibus%20window%20at%20night%2C%20neon%20reflections%20on%20wet%20streets%2C%20warm%20amber%20and%20teal%20highlights%2C%20early%202000s%20hong%20kong%20cinema%20aesthetic%2C%20film%20grain&width=800&height=1200&seq=cecilia-work-002&orientation=portrait",
    stills: [
      {
        src: "https://readdy.ai/api/search-image?query=Film%20still%20of%20a%20red%20minibus%20driving%20through%20a%20wet%20hong%20kong%20street%20at%20night%2C%20neon%20signs%20reflected%20on%20asphalt%2C%20warm%20amber%20streetlights%2C%20nostalgic%20early%202000s%20cinematography&width=1200&height=800&seq=cecilia-still-002a&orientation=landscape",
        alt: "《忘不了》剧照 夜班小巴",
      },
      {
        src: "https://readdy.ai/api/search-image?query=Close%20up%20film%20still%20of%20a%20young%20woman%20looking%20out%20of%20a%20bus%20window%20at%20night%2C%20city%20lights%20bokeh%20outside%2C%20warm%20skin%20tones%2C%20melancholic%20quiet%20expression%2C%20cinematic%20grain&width=1200&height=800&seq=cecilia-still-002b&orientation=landscape",
        alt: "《忘不了》剧照 车窗前的凝望",
      },
    ],
    heat: 92,
    highlight: "港产文艺片代表作",
  },
  {
    id: "w003",
    title: "喜剧之王",
    enTitle: "King of Comedy",
    type: "电影",
    year: 1999,
    director: "周星驰",
    role: "飘飘",
    coStars: ["周星驰", "莫文蔚"],
    synopsis:
      "一个跑龙套的小演员和一个在夜场工作的女孩，在社区服务中心的表演课上相遇。两个不肯承认自己孤独的人，用最笨拙的方式交换了一点温暖。",
    roleIntro:
      "飘飘这个角色让张柏芝一夜之间被全香港记住。素颜、白衬衫、海风吹乱的头发，她在海边那句“你养我啊”的回应，成为无数观众心里最难忘的镜头。",
    cover:
      "https://readdy.ai/api/search-image?query=Vertical%20retro%20movie%20poster%20of%20a%20young%20woman%20in%20a%20white%20shirt%20standing%20by%20the%20sea%20at%20sunset%2C%20wind%20blowing%20her%20hair%2C%20warm%20orange%20and%20soft%20pink%20sky%2C%20nineteen%20nineties%20hong%20kong%20film%20aesthetic%2C%20grainy%20nostalgic%20texture&width=800&height=1200&seq=cecilia-work-003&orientation=portrait",
    stills: [
      {
        src: "https://readdy.ai/api/search-image?query=Film%20still%20of%20a%20seaside%20promenade%20at%20golden%20hour%2C%20two%20figures%20silhouetted%20near%20the%20railing%2C%20warm%20orange%20sunlight%20on%20the%20water%2C%20nostalgic%201990s%20film%20grain%2C%20romantic%20cinematic%20composition&width=1200&height=800&seq=cecilia-still-003a&orientation=landscape",
        alt: "《喜剧之王》剧照 海边黄昏",
      },
      {
        src: "https://readdy.ai/api/search-image?query=Film%20still%20of%20a%20small%20community%20center%20classroom%20with%20wooden%20chairs%20and%20a%20blackboard%2C%20soft%20afternoon%20light%20through%20old%20windows%2C%20warm%20sepia%20tones%2C%20quiet%20nostalgic%20atmosphere&width=1200&height=800&seq=cecilia-still-003b&orientation=landscape",
        alt: "《喜剧之王》剧照 社区中心",
      },
    ],
    heat: 98,
    highlight: "影史经典镜头",
  },
  {
    id: "w004",
    title: "一屋三餐",
    enTitle: "Three Meals, One House",
    type: "综艺",
    year: 2026,
    director: "李慕之",
    role: "常驻嘉宾",
    coStars: ["黄觉", "周依然", "阿雅"],
    synopsis:
      "四位嘉宾在一栋租来的老屋里生活十二天，自己买菜、做饭、打扫，并与附近的素人邻居一同吃三餐。节目不设任务，只记录真实的生活节奏。",
    roleIntro:
      "这是张柏芝首次常驻生活类综艺。她在节目中承担了大部分下厨工作，也第一次在镜头前完整地讲起自己的家常菜谱和厨房习惯。",
    cover:
      "https://readdy.ai/api/search-image?query=Vertical%20warm%20poster%20of%20a%20cozy%20old%20house%20kitchen%20with%20wooden%20cabinets%2C%20steaming%20pots%20on%20a%20gas%20stove%2C%20fresh%20vegetables%20and%20ceramic%20bowls%2C%20golden%20morning%20light%20through%20linen%20curtains%2C%20homely%20documentary%20photography%2C%20beige%20and%20terracotta%20palette&width=800&height=1200&seq=cecilia-work-004&orientation=portrait",
    stills: [
      {
        src: "https://readdy.ai/api/search-image?query=Documentary%20photograph%20of%20a%20rustic%20kitchen%20counter%20with%20chopped%20tomatoes%20and%20eggs%20in%20a%20ceramic%20bowl%2C%20wooden%20utensils%2C%20warm%20natural%20light%2C%20soft%20focus%2C%20cozy%20home%20cooking%20atmosphere&width=1200&height=800&seq=cecilia-still-004a&orientation=landscape",
        alt: "《一屋三餐》画面 备菜",
      },
      {
        src: "https://readdy.ai/api/search-image?query=Warm%20evening%20dining%20table%20in%20an%20old%20house%20with%20several%20simple%20home%20cooked%20dishes%2C%20mismatched%20ceramic%20plates%2C%20a%20small%20lamp%20glowing%2C%20inviting%20intimate%20mood%2C%20soft%20amber%20tones&width=1200&height=800&seq=cecilia-still-004b&orientation=landscape",
        alt: "《一屋三餐》画面 晚餐桌",
      },
    ],
    heat: 88,
    highlight: "首次常驻生活综艺",
  },
  {
    id: "w005",
    title: "河东狮吼",
    enTitle: "The Lion Roars",
    type: "电影",
    year: 2002,
    director: "马伟豪",
    role: "柳月娥",
    coStars: ["古天乐", "范冰冰"],
    synopsis:
      "一位性情刚烈的女子与书生陈季常成婚，婚后两人在琐碎日常里不断碰撞。一部包裹在古装喜剧外壳下的婚姻观察。",
    roleIntro:
      "柳月娥的“凶”其实是一种防御。张柏芝在这部喜剧里展现了极强的节奏感与肢体控制，把一个容易变成符号的角色演出了委屈和可爱。",
    cover:
      "https://readdy.ai/api/search-image?query=Vertical%20ancient%20chinese%20costume%20drama%20poster%20of%20a%20woman%20in%20an%20elegant%20cream%20and%20gold%20hanfu%20standing%20in%20a%20traditional%20courtyard%20with%20red%20lanterns%2C%20soft%20bokeh%20background%2C%20warm%20ochre%20and%20crimson%20tones%2C%20painterly%20cinematic%20style&width=800&height=1200&seq=cecilia-work-005&orientation=portrait",
    stills: [
      {
        src: "https://readdy.ai/api/search-image?query=Film%20still%20of%20a%20traditional%20chinese%20courtyard%20with%20stone%20paving%20and%20blossoming%20trees%2C%20warm%20afternoon%20light%2C%20red%20lanterns%20hanging%20under%20eaves%2C%20soft%20cinematic%20haze%2C%20painterly%20composition&width=1200&height=800&seq=cecilia-still-005a&orientation=landscape",
        alt: "《河东狮吼》剧照 庭院",
      },
      {
        src: "https://readdy.ai/api/search-image?query=Film%20still%20of%20a%20wooden%20study%20room%20with%20scrolls%2C%20ink%20stone%20and%20a%20brass%20oil%20lamp%2C%20warm%20amber%20lighting%2C%20soft%20shadows%2C%20classical%20chinese%20interior%20with%20elegant%20minimal%20props&width=1200&height=800&seq=cecilia-still-005b&orientation=landscape",
        alt: "《河东狮吼》剧照 书房",
      },
    ],
    heat: 84,
    highlight: "古装喜剧代表作",
  },
  {
    id: "w006",
    title: "如果·爱",
    enTitle: "Perhaps Love",
    type: "电影",
    year: 2005,
    director: "陈可辛",
    role: "孙纳（客串）",
    coStars: ["周迅", "金城武", "张学友"],
    synopsis:
      "在一部歌舞片的拍摄现场，导演、女演员与她十年前的爱人之间的关系逐渐纠缠。记忆与现实在同一场景里不断重叠。",
    roleIntro:
      "虽然是客串，但她出场的那场戏成为影片中讨论度极高的片段之一。她用极短的篇幅交代了一个角色十年的生活方式。",
    cover:
      "https://readdy.ai/api/search-image?query=Vertical%20musical%20film%20poster%20with%20a%20woman%20in%20a%20deep%20terracotta%20silk%20dress%20under%20a%20warm%20spotlight%20on%20a%20dark%20stage%2C%20soft%20haze%20and%20light%20beams%2C%20theatrical%20elegant%20composition%2C%20rich%20amber%20and%20charcoal%20palette&width=800&height=1200&seq=cecilia-work-006&orientation=portrait",
    stills: [
      {
        src: "https://readdy.ai/api/search-image?query=Theatrical%20stage%20with%20warm%20spotlights%20cutting%20through%20haze%2C%20empty%20red%20velvet%20seats%20in%20the%20foreground%2C%20moody%20cinematic%20photography%2C%20deep%20amber%20and%20brown%20tones&width=1200&height=800&seq=cecilia-still-006a&orientation=landscape",
        alt: "《如果·爱》剧照 舞台",
      },
    ],
    heat: 76,
    highlight: "歌舞片高光客串",
  },
  {
    id: "w007",
    title: "长江七号",
    enTitle: "CJ7",
    type: "电影",
    year: 2008,
    director: "周星驰",
    role: "袁老师",
    coStars: ["周星驰", "徐娇"],
    synopsis:
      "一对生活在旧楼里的父子捡到一个奇怪的小生物，生活由此发生改变。一位小学老师成为这个家庭最温暖的旁观者。",
    roleIntro:
      "袁老师是一个克制、清瘦的角色。她的每一次出现都像一束很薄的光，安静地照在这个努力生活的家庭旁边。",
    cover:
      "https://readdy.ai/api/search-image?query=Vertical%20warm%20family%20film%20poster%20of%20an%20old%20hong%20kong%20apartment%20block%20with%20laundry%20hanging%20outside%20windows%2C%20late%20afternoon%20golden%20light%2C%20a%20woman%20in%20a%20pale%20blouse%20standing%20on%20the%20staircase%2C%20nostalgic%20warm%20beige%20palette&width=800&height=1200&seq=cecilia-work-007&orientation=portrait",
    stills: [
      {
        src: "https://readdy.ai/api/search-image?query=Film%20still%20of%20an%20old%20school%20classroom%20with%20wooden%20desks%20and%20chalk%20dust%20in%20the%20afternoon%20sunlight%2C%20warm%20sepia%20tones%2C%20nostalgic%20documentary%20style&width=1200&height=800&seq=cecilia-still-007a&orientation=landscape",
        alt: "《长江七号》剧照 教室",
      },
    ],
    heat: 80,
    highlight: "温情家庭喜剧",
  },
  {
    id: "w008",
    title: "影子爱人",
    enTitle: "Shadows of Love",
    type: "电影",
    year: 2012,
    director: "潘源良",
    role: "碧琪",
    coStars: ["权相佑", "景甜"],
    synopsis:
      "两个长相相似的女子，一个在城市里追逐名利，一个安静地生活。一场交换身份的意外，让彼此的人生互相照见。",
    roleIntro:
      "一人分饰两角对表演的分寸要求极高。她通过语速、步态和眼神的细微差别，让两个女性在银幕上保持了清晰的距离感。",
    cover:
      "https://readdy.ai/api/search-image?query=Vertical%20romantic%20film%20poster%20showing%20a%20woman%20reflected%20in%20a%20large%20mirror%20in%20a%20dim%20elegant%20hotel%20room%2C%20soft%20amber%20lamplight%2C%20moody%20warm%20brown%20palette%2C%20cinematic%20melancholy%2C%20double%20exposure%20feel&width=800&height=1200&seq=cecilia-work-008&orientation=portrait",
    stills: [
      {
        src: "https://readdy.ai/api/search-image?query=Romantic%20film%20still%20of%20an%20elegant%20hotel%20corridor%20with%20warm%20wall%20sconces%20and%20patterned%20carpet%2C%20soft%20shadows%2C%20muted%20ochre%20and%20cream%20tones%2C%20cinematic%20depth&width=1200&height=800&seq=cecilia-still-008a&orientation=landscape",
        alt: "《影子爱人》剧照 酒店走廊",
      },
    ],
    heat: 68,
    highlight: "一人分饰两角",
  },
  {
    id: "w009",
    title: "一路有你",
    enTitle: "The Road Less Travelled",
    type: "电影",
    year: 2010,
    director: "赵崇基",
    role: "苏蔓",
    coStars: ["古天乐", "莫文蔚"],
    synopsis:
      "一次长途自驾，把两个原本陌生的人放在同一辆车里。沿途的风景与沉默，慢慢拼出一个关于原谅的故事。",
    roleIntro:
      "苏蔓是一个不太会表达的女性，她的情绪都藏在握着方向盘的力度和某一瞬间的停顿里。",
    cover:
      "https://readdy.ai/api/search-image?query=Vertical%20road%20movie%20poster%20of%20a%20winding%20mountain%20highway%20at%20sunset%2C%20warm%20orange%20sky%20with%20soft%20clouds%2C%20a%20car%20driving%20into%20the%20distance%2C%20minimal%20cinematic%20composition%2C%20muted%20earth%20tones&width=800&height=1200&seq=cecilia-work-009&orientation=portrait",
    stills: [
      {
        src: "https://readdy.ai/api/search-image?query=Film%20still%20of%20a%20mountain%20road%20viewpoint%20at%20golden%20hour%2C%20dry%20grass%20and%20stone%20guardrail%2C%20warm%20sunlight%20flaring%20over%20the%20horizon%2C%20soft%20film%20grain%2C%20melancholic%20travel%20cinematography&width=1200&height=800&seq=cecilia-still-009a&orientation=landscape",
        alt: "《一路有你》剧照 山路",
      },
    ],
    heat: 62,
    highlight: "公路题材",
  },
  {
    id: "w010",
    title: "明星访谈实录",
    enTitle: "In Conversation",
    type: "综艺",
    year: 2025,
    director: "陈小漫",
    role: "受访嘉宾（第 4 期）",
    coStars: ["主持人 何宁"],
    synopsis:
      "一档不设互动环节的长访谈节目，每期只与一位嘉宾坐下来，聊两个小时的作品与人生。",
    roleIntro:
      "在那期节目里，她完整地谈到了自己十六岁入行、第一次拿奖、以及为什么在事业最好的时候选择休息。",
    cover:
      "https://readdy.ai/api/search-image?query=Vertical%20interview%20studio%20poster%20with%20two%20simple%20armchairs%20on%20a%20warm%20beige%20backdrop%2C%20soft%20directional%20lighting%2C%20minimal%20talk%20show%20set%20design%2C%20cream%20and%20amber%20tones%2C%20elegant%20editorial%20style&width=800&height=1200&seq=cecilia-work-010&orientation=portrait",
    stills: [
      {
        src: "https://readdy.ai/api/search-image?query=Minimal%20talk%20show%20set%20with%20a%20low%20wooden%20table%2C%20two%20linen%20chairs%2C%20warm%20beige%20seamless%20backdrop%2C%20soft%20studio%20lighting%20with%20gentle%20shadows%2C%20editorial%20photography&width=1200&height=800&seq=cecilia-still-010a&orientation=landscape",
        alt: "《明星访谈实录》节目现场",
      },
    ],
    heat: 72,
    highlight: "两小时深度长谈",
  },
];